import { create } from 'zustand'

export type StationGeneralSettings = {
  autoSendQuickReplies: boolean
  enterToSend: boolean
  loaded: boolean
}

type StationGeneralEntryInput = {
  autoSendQuickReplies: boolean
  enterToSend: boolean
}

type StationGeneralSettingsState = {
  generalSettings: Record<number, StationGeneralSettings>
  setGeneralSettings: (stationId: number, settings: StationGeneralEntryInput) => void
  setManyGeneralSettings: (entries: Array<{ stationId: number; settings: StationGeneralEntryInput }>) => void
  clearGeneralSettings: (stationId: number) => void
  reset: () => void
}

const useStationGeneralSettingsStore = create<StationGeneralSettingsState>((set) => ({
  generalSettings: {},
  setGeneralSettings: (stationId, settings) => {
    if (!Number.isFinite(stationId) || stationId <= 0) {
      return
    }

    set((state) => ({
      generalSettings: {
        ...state.generalSettings,
        [stationId]: {
          autoSendQuickReplies: Boolean(settings.autoSendQuickReplies),
          enterToSend: Boolean(settings.enterToSend),
          loaded: true,
        },
      },
    }))
  },
  setManyGeneralSettings: (entries) => {
    if (!entries.length) {
      return
    }

    set((state) => {
      const next = { ...state.generalSettings }

      for (const entry of entries) {
        if (!Number.isFinite(entry.stationId) || entry.stationId <= 0) {
          continue
        }

        next[entry.stationId] = {
          autoSendQuickReplies: Boolean(entry.settings.autoSendQuickReplies),
          enterToSend: Boolean(entry.settings.enterToSend),
          loaded: true,
        }
      }

      return { generalSettings: next }
    })
  },
  clearGeneralSettings: (stationId) => {
    if (!Number.isFinite(stationId) || stationId <= 0) {
      return
    }

    set((state) => {
      if (!(stationId in state.generalSettings)) {
        return state
      }

      const next = { ...state.generalSettings }
      delete next[stationId]

      return { generalSettings: next }
    })
  },
  reset: () => set({ generalSettings: {} }),
}))

export default useStationGeneralSettingsStore
